import * as Util from "../common/util";
import * as AvailableRoles from "../interfaces/availableRoles";
import * as Data from "../interfaces/data";

export interface ISettingType {
    ID: number;
    SettingType: string;
    SettingKey: string;
}

export interface ICustomerMasterSettings {
    CustomerSettings: ICustomerSetting[];
    CustomerImages: ICustomerImage[];
    SettingTypes: ISettingType[];
    UserRoles: AvailableRoles.IUserRoles[];
    TemplateAccessRoles: AvailableRoles.ITemplateAccessRoles[];

}

export interface ICustomerAllSettings {
    CustomerSettings: ICustomerSetting[];
    CustomerImages: ICustomerImage[];
}

export interface ICustomerAllSettingsSaveResponse {
    ID: number;
}
export interface ICustomerSetting {
     ID: number;

    // CustomerSettingTypeID from CustomerSettingTypes
    CustomerSettingTypeID: number;

    // SettingKey holds data "Mobile Primary Color".
    SettingKey: string;

    // value holds hex value of the color.
    Value: string;

    // example "color"
    SettingType: string;
    IsActive: boolean;
}

export interface ICustomerImage {
    ID: number;

    // CustomerSettingTypeID from CustomerSettingTypes
    CustomerSettingTypeID: number;

    // SettingKey holds data "Mobile Primary Color".
    SettingKey: string;

    /// The base-64 encoded image data
    ImageData: string;

    IsActive: boolean;

    /// The key that links to a temporary image in S3.  Used when saving a newly-uploaded image.
    TempFileKey: string;

    FileExtension: string;
}

export function GetAllSettings(): JQueryDeferred<Data.IResponse<ICustomerMasterSettings>> {
    return Util.callWebService(
        "/api/CustomerSettings/GetAllSettings", "GET");
}

export function SaveCustomerSettings(customerAllSettings: any): JQueryDeferred<Data.IResponse<ICustomerAllSettingsSaveResponse>> {
    return Util.callWebService(
        "/api/CustomerSettings/Save", "POST", customerAllSettings );
}

export function GetAllSettingsForCustomer(customerID: number): JQueryDeferred<Data.IResponse<ICustomerMasterSettings>> {
    return Util.callWebService(`/api/CustomerSettings/GetAllSettingsForCustomer/${customerID}`, "GET");
}

export function SaveForCustomer(customerID: number, customerAllSettings: any): JQueryDeferred<Data.IResponse<ICustomerAllSettingsSaveResponse>> {
    return Util.callWebService(
        `/api/CustomerSettings/SaveforCustomer/${customerID}`, "POST", customerAllSettings);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/customerSettingsData.ts